import React, { FC } from 'react';
import { TypeEmbeddedVideoAndTextSideBySideFields } from '@/core/generated-types';
import { BackgroundColorWrapper } from '@/components/common/BackgroundColorWrapper';
import { VideoEmbed } from '@/components/common/VideoEmbed/VideoEmbed';
import { UniversalCta } from '../UniversalCta';
import classNames from 'classnames';

export const EmbeddedVideoAndTextSideBySide: FC<
  TypeEmbeddedVideoAndTextSideBySideFields
> = ({
  entryName,
  accentText = '',
  heading = '',
  mainText = '',
  videoEmbed,
  backgroundColor,
  cta,
  videoLeft,
}) => {
  return (
    <section data-testid={`embedded-video-and-text-side-by-side-${entryName}`}>
      <BackgroundColorWrapper
        color={backgroundColor?.fields?.color}
        applyGutters
        classes={'py-7 lg:py-14 relative'}
      >
        <div className="relative z-10 mx-auto px-6 md:container md:px-0">
          <div className="mb-10 flex flex-col items-center text-center lg:mb-16 lg:flex-row lg:text-left">
            <div
              className={classNames(
                videoLeft ? 'lg:order-1' : 'lg:order-0',
                'order-1 w-full px-8 lg:w-2/5',
              )}
            >
              {accentText && (
                <div className="mb-3 text-d-lg text-purple lg:mb-6">
                  {accentText}
                </div>
              )}
              {heading && (
                <h3 className="mb-2 text-h-x4 font-bold lg:mb-3 lg:text-h-x3">
                  {heading}
                </h3>
              )}
              {mainText && <div className="leading-6 lg:pr-12">{mainText}</div>}
            </div>
            <div
              className={classNames(
                videoLeft ? 'lg:order-0' : 'lg:order-1',
                'order-0 mb-6 w-full lg:mb-0 lg:w-3/5',
              )}
            >
              <div className="aspect-h-9 aspect-w-16 relative z-10 mx-auto">
                <VideoEmbed
                  classes="mx-auto max-h-[556px] w-full"
                  {...videoEmbed.fields}
                />
              </div>
            </div>
          </div>
          <div className="text-center">
            {cta && <UniversalCta link={cta} />}
          </div>
        </div>
      </BackgroundColorWrapper>
    </section>
  );
};
